import { Fragment } from "react";
import styled from "styled-components";

import { modularScale } from "@otta/design-tokens";
import { media, Spacing, Text } from "@otta/design";

const CopyMatrix = styled.div`
  justify-content: flex-start;
  flex-grow: 1;
  text-align: left;
`;

const CopyValuesContainer = styled.div`
  display: grid;
  grid-row-gap: ${modularScale(-1)};
  grid-template-columns: 1fr;
  ${media({ from: "tablet" })`
    grid-row-gap: ${modularScale(-5)};
    grid-template-columns: auto 1fr;
  `}
`;

const CopyLabel = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-right: ${modularScale()};

  ${media({ from: "tablet" })`
    justify-content: flex-end;
    text-align: right;
  `}
`;

export const CopyPasteMatrix = ({
  helpText,
  rows,
}: {
  helpText: string;
  rows: { label: string; element: React.ReactNode }[];
}): React.ReactElement => (
  <CopyMatrix>
    <Spacing size={-1}>
      <Text>{helpText}</Text>
      <CopyValuesContainer>
        {rows.map(({ label, element }) => (
          <Fragment key={label}>
            <CopyLabel>{label}</CopyLabel>
            {element}
          </Fragment>
        ))}
      </CopyValuesContainer>
    </Spacing>
  </CopyMatrix>
);
